<template>
  <div class="main__spinner" :class="centerInPage">
    <div class="lds-ripple">
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "spinner",
  props: ["center"],
  computed: {
    centerInPage: function() {
      return this.center && "center__spinner";
    },
  },
};
</script>
